import { render } from "./SettingsInstances.vue?vue&type=template&id=e1efc08e"
import script from "./SettingsInstances.vue?vue&type=script&lang=js"
export * from "./SettingsInstances.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__